// extracted by mini-css-extract-plugin
module.exports = {"card":"banner_card__S9hBr","image":"banner_image___XBly"};